import { useEffect, useState } from "react";
import SmoothScroll from "smooth-scroll";
import { JoinCommunity } from "./components/JoinCommunity";
import { OurServices } from "./components/OurServices";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import { Features } from "./components/features";
import { Header } from "./components/header";
import { Navigation } from "./components/navigation";
import { SearchBar } from "./components/searchBar";
import { Testimonials } from "./components/testimonials";
import JsonData from "./data/data.json";
import { Helmet } from "react-helmet-async";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const LandingPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Nannies Desk - Find the best nannies for your family</title>
        <meta name="description" content="Find the best nannies for your family" />

        <meta property="og:title" content="Nannies Desk - Find the best nannies for your family" />
        <meta property="og:description" content="Find the best nannies for your family" />
      </Helmet>
      <Navigation />
      <Header data={landingPageData.Header} />
      <SearchBar />
      <OurServices />
      <Features data={landingPageData.Features} />
      {/* <CaregiverFilter />
      <CaregiverListing /> */}
      <About data={landingPageData.About} />
      {/* <Services data={landingPageData.Services} /> */}
      {/* <Gallery data={landingPageData.Gallery} /> */}
      <Testimonials data={landingPageData.Testimonials} />
      <JoinCommunity />
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default LandingPage;
